var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopsDeco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 2950 1639",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_dNS4bVXMlCpMt16KZbKmdYQ3gEboKmXz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2950,
    height: 1639
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_dNS4bVXMlCpMt16KZbKmdYQ3gEboKmXz)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_mJwFDdH1XgL4U4J4NsVJ7Hh2WKzKsPXr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2950,
    height: 1639,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_mJwFDdH1XgL4U4J4NsVJ7Hh2WKzKsPXr)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2950,
    height: 1639,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(0,25,73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 0 1856.712 C 259.08 1922.706 505.328 1676.519 718.245 1471.295 C 921.956 1274.945 1093.209 1022.175 1186.337 713.237 C 1276.741 413.336 1253.405 88.224 1232.057 -233.203 C 1209.527 -572.436 1250.345 -978.96 1058.755 -1207.747 C 865.781 -1438.186 552.642 -1261.101 300.207 -1345.969 C 60.87 -1426.434 -141.112 -1786.794 -377.044 -1690.465 C -613.624 -1593.87 -642.102 -1162.714 -789.789 -900.931 C -923.091 -664.647 -1127.808 -505.065 -1202.34 -227.577 C -1285.743 82.94 -1361.736 459.389 -1230.474 739.774 C -1098.632 1021.398 -766.249 958.063 -559.372 1145.852 C -341.605 1343.526 -259.7 1790.559 0 1856.712 Z ",
    fill: "rgb(2,101,244)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopsDeco);
export default __webpack_public_path__ + "static/media/ShopsDeco.909e7852944ee357e009be94a8fa8917.svg";
export { ForwardRef as ReactComponent };